import React, { FC, useState }                from "react";
import { useDispatch }                                 from "react-redux";
import { Button, Card, Divider, List, Message, Modal } from "semantic-ui-react";
import AcceptReservationCancelRequest
                                                       from "../../../../application/usecase/reservation/cancel/AcceptReservationCancelRequest";
import ReservationHistory                     from "../../../../domain/reservation/history/ReservationHistory";

type Props = {
  history: ReservationHistory;
}

const ReservationHistoryCard: FC<Props> = ({history}) => {
  const [open, setOpen] = useState(false);
  const acceptReservationCancelRequest = new AcceptReservationCancelRequest(useDispatch());

  return (
    <>
      <Card>
        <Card.Content>
          <Card.Header>
            { history.reservation.detail.date.asText() }
            &nbsp;&nbsp;
            { history.reservation.detail.timePeriod.from.asText() }
            &nbsp;～&nbsp;
            { history.reservation.detail.timePeriod.to.asText() }
          </Card.Header>
        </Card.Content>
        <Card.Content>
          <Card.Description>
            <List>
              <List.Item>
                <List.Icon name="user"/>
                <List.Content>{ history.reservation.customer.detail.name.asFull() }</List.Content>
              </List.Item>
              <List.Item>
                <List.Icon name="phone"/>
                <List.Content>{ history.reservation.customer.contact.phone.value }</List.Content>
              </List.Item>
              <List.Item>
                <List.Icon name="mail"/>
                <List.Content>{ history.reservation.customer.contact.email.value }</List.Content>
              </List.Item>
            </List>
          </Card.Description>
        </Card.Content>
        <Card.Content extra textAlign="center">
          <Modal
            onOpen={ () => setOpen(true) }
            open={ open }
            size="tiny"
            trigger={ <Button negative>予約キャンセルを確定する</Button> }
          >
            <Modal.Header>予約キャンセルを確定します。よろしいですか？</Modal.Header>
            <Modal.Content>
              <Message warning>
                <p>予約キャンセルを確定すると、該当する予約情報が削除されます。</p>
              </Message>
              <List horizontal>
                <List.Item>
                  <List.Content>
                    <List.Header><List.Icon name="calendar" size="large"/>予約日</List.Header>
                    <p>{ history.reservation.detail.date.asText() }</p>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header><List.Icon name="time" size="large"/>予約時間</List.Header>
                    <p>
                      { history.reservation.detail.timePeriod.from.asText() }
                      &nbsp;～&nbsp;
                      { history.reservation.detail.timePeriod.to.asText() }
                    </p>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header><List.Icon name="ticket" size="large"/>プラン名</List.Header>
                    <p>{ history.plan.name.toString() }</p>
                  </List.Content>
                </List.Item>
              </List>
              <Divider/>
              <List>
                <List.Item>
                  <List.Icon name="user" size="large" verticalAlign="middle"/>
                  <List.Content>
                    <List.Header>予約者名</List.Header>
                    <p>{ history.reservation.customer.detail.name.asFull() }</p>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="phone" size="large" verticalAlign="middle"/>
                  <List.Content>
                    <List.Header>電話番号</List.Header>
                    <p>{ history.reservation.customer.contact.phone.value }</p>
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="mail" size="large" verticalAlign="middle"/>
                  <List.Content>
                    <List.Header>Eメールアドレス</List.Header>
                    <p>{ history.reservation.customer.contact.email.value }</p>
                  </List.Content>
                </List.Item>
              </List>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={ () => setOpen(false) }>閉じる</Button>
              <Button
                negative
                onClick={ () => {
                  setOpen(false);
                  acceptReservationCancelRequest.execute(history.reservation.id);
                } }
              >
                予約キャンセルを確定する
              </Button>
            </Modal.Actions>
          </Modal>
        </Card.Content>
      </Card>
    </>
  );
};

export default ReservationHistoryCard;
